import { useState } from "react";
import AppLayout from "@/components/feature/AppLayout";
import Breadcrumb from "@/components/feature/Breadcrumb";
import ArtCard from "@/components/feature/ArtCard";
import useSeo from "@/hooks/useSeo";
import { artWorks } from "@/mocks/narutoContent";

const filters = ["全部", "高清壁纸", "同人插画"];

export default function Gallery() {
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? artWorks : artWorks.filter((a) => a.type === active);

  useSeo({
    title: "火影忍者同人图·高清壁纸 - 插画下载 | 影页社",
    description:
      "影页社火影忍者同人图与高清壁纸栏目，精选同人插画与壁纸，涵盖角色立绘、战斗名场面与四季风景，支持火影忍者同人壁纸、插画在线浏览与下载收藏。",
    keywords: "火影忍者同人图,火影忍者同人壁纸,火影忍者同人插画,火影忍者壁纸高清",
    canonical: "https://wn-baidu.cn/tongrentu",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "ImageGallery",
        name: "影页社 · 火影忍者同人图与壁纸",
        description: "火影忍者同人插画与高清壁纸精选",
        url: "https://wn-baidu.cn/tongrentu",
        image: artWorks.map((a) => a.cover),
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "首页", item: "https://wn-baidu.cn/" },
          { "@type": "ListItem", position: 2, name: "同人图·壁纸", item: "https://wn-baidu.cn/tongrentu" },
        ],
      },
    ],
  });

  return (
    <AppLayout>
      <div className="pt-20">
        <Breadcrumb items={[{ name: "同人图 · 壁纸" }]} />

        <header className="mx-auto w-full max-w-7xl px-4 md:px-6 pt-6 pb-4">
          <h1 className="font-display text-3xl md:text-4xl text-foreground-950">同人图 · 高清壁纸</h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            精选火影忍者同人插画与高清壁纸，从角色立绘到四季风景，从热血战斗到温情日常。点击图片可预览，高清壁纸支持一键下载。
          </p>
        </header>

        {/* 筛选 */}
        <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-4">
          <div className="inline-flex flex-wrap items-center gap-2 rounded-full border border-background-200 bg-background-100 p-1">
            {filters.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setActive(f)}
                className={`rounded-full px-4 py-2 font-label text-sm whitespace-nowrap transition-colors ${
                  active === f ? "bg-primary-500 text-background-50" : "text-foreground-700 hover:bg-secondary-100"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        {/* 画廊网格 */}
        <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-6 pb-16">
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((a) => (
              <ArtCard key={a.id} work={a} />
            ))}
          </div>
          {list.length === 0 && (
            <p className="py-16 text-center text-sm text-foreground-500">该分类下暂无内容，敬请期待。</p>
          )}

          {/* 下载提示 */}
          <div className="mt-10 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <h2 className="font-display text-xl text-foreground-950">壁纸与插画使用说明</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              本站收录的火影忍者同人图均为同好创作，标注了作者署名，供个人欣赏与设备壁纸等非商业用途。若需转载或用于商业场景，请务必先联系原作者取得授权，并注明出处。尊重每一位画手的付出，才能让同人创作走得更远。
            </p>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}